module.exports = __webpack_public_path__ + "../static/img/alchemy_logo.895ed157.png";